import React from "react";

const StopWatchIcon = () => {
  return (
    <svg
      width="714"
      height="801"
      viewBox="0 0 714 801"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="h-[20px] w-[20px]"
    >
      <path
        d="M677.269 202.234C681.472 206.437 686.974 208.538 692.481 208.538C697.986 208.538 703.493 206.437 707.691 202.237C716.094 193.837 716.094 180.217 707.693 171.816L629.993 94.1135C621.593 85.713 607.973 85.713 599.572 94.1108C591.169 102.511 591.169 116.131 599.57 124.532L608.002 132.965L562.547 177.971C514.244 140.231 456.069 114.943 391.532 106.981V43.5246H403.184C415.064 43.5246 424.696 33.8925 424.696 22.0123C424.696 10.1321 415.064 0.5 403.184 0.5H292.933C281.053 0.5 271.421 10.1321 271.421 22.0123C271.421 33.8925 281.053 43.5246 292.933 43.5246H305.483V106.897C133.385 128.006 0.5 274.89 0.5 452.388C0.5 644.337 156.887 800.497 348.833 800.497C540.778 800.497 697.055 644.339 697.055 452.39C697.055 371.983 669.697 297.862 623.739 238.865L668.818 193.812L677.269 202.234ZM326.995 408.382V255.118C326.995 243.237 336.627 233.605 348.507 233.605C360.388 233.605 370.02 243.237 370.02 255.118V408.715C386.154 416.739 397.448 433.236 397.448 452.345C397.448 479.313 375.804 501.178 348.833 501.178C321.865 501.178 299.658 479.313 299.658 452.345C299.658 432.962 310.861 416.271 326.995 408.382Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export default StopWatchIcon;
